import { createSelector } from 'reselect';

import type { IApplicationState } from '../../../types/redux';
import type { IMenuBlockItemsSchema } from '../../../repositories/journal/entities/menu/MenuBlockItemsSchema';
import { transformGroup } from './transformGroup';

const selectMenuItems = (state: IApplicationState): IMenuBlockItemsSchema[] => state.menu.items;

/**
 * Селектор групп меню с трансформацией формата (мемоизация по ссылке menu.items)
 */
export const selectAllGroups = createSelector([selectMenuItems], items => items.map(item => transformGroup(item)));
